export class TokenEntity {
  id;
  value;
  displayValue;
  siteId;
  userTypeId;
  isBillingEnabled;
  deleted;

  constructor(
    id,
    value,
    displayValue,
    siteId,
    userTypeId,
    isBillingEnabled,
    deleted
  ) {
    this.id = id;
    this.value = value;
    this.displayValue = displayValue;
    this.siteId = siteId;
    this.userTypeId = userTypeId;
    this.isBillingEnabled = isBillingEnabled;
    this.deleted = deleted;
  }
}
